export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/components/app-sidebar-minimizer/index.ts